// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"success-story_wrapper__L87MQ","titleWrap":"success-story_titleWrap__8iFAk"};